import useFetchData, { FetchDataProps } from "./use-fetch-data";
export interface MessageResponse {
  message?: string;
}

function FetchData<T extends MessageResponse>(props: FetchDataProps<T>) {
  
  useFetchData({
    ...props,
    enabled: true,
  })
  return null; //<input type="hidden" name={`fetch#${counter}`} value={counter} />;
}

export default FetchData;
